import type { ZInfer, monetaryDonationSchemas } from 'types';
import { Api } from '../fetch';

export class DonateNet {
  static complete = (body: ZInfer<typeof monetaryDonationSchemas.request>) =>
    Api.post<'donate', 'create'>(`/donate`, { body });
  static cancelIntent = (intent: string) =>
    Api.delete<'donate', 'cancelIntent'>(`/donate/intent`, { body: { intent } });
  static voidInvoice = (intent: string) => Api.delete<'donate', 'voidInvoice'>(`/donate/invoice`, { body: { intent } });

  static stripe = {
    portal: () => Api.get<'stripe', 'portal'>(`/stripe/portal`),
  };
}
